// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:27:37

export default {
  "id": "youtuber-mcraft-2player",
  "slug": "youtuber-mcraft-2player",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1af135df04c44b60a54bd78b5c998c6d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1af135df04c44b60a54bd78b5c998c6d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Youtuber Mcraft 2Player",
      "description": "You need to help the YouTuber girl and her boyfriend escape from prison. In this two-player adventure, they must collect all the YouTube plaques without getting too far apart, obtain the key and the golden plaque, and reach the chest. Open the chest and run to the door. You need to be very fast, you must escape from prison!",
      "instructions": "*Use the \"WASD\" and \"Arrow keys\" to move.\n*Double Jump available.\n*Collect all YouTube plaques and find the key.\n*After finding the key, reach the chest.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "2d",
        "2players",
        "minecraft",
        "platformer",
        "tycoon"
      ]
    },
    "zh-CN": {
      "title": "油管博主Mcraft双人游戏",
      "description": "你需要帮助这个YouTube女孩和她的男朋友从监狱逃脱。在这款双人冒险游戏中，他们必须收集所有YouTube奖牌，同时不要离得太远，获取钥匙和金色奖牌，并到达宝箱。打开宝箱，然后跑到门口。你必须非常快，你必须从监狱逃脱！",
      "instructions": "*使用“WASD”和“箭头键”进行移动。\n*可进行双跳。\n*收集所有YouTube奖牌并找到钥匙。\n*找到钥匙后，到达宝箱。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "2D",
        "2人玩家",
        "我的世界",
        "平台游戏",
        "模拟经营"
      ]
    },
    "zh-TW": {
      "title": "油管頻道 Mcraft 2Player",
      "description": "你需要幫助那位YouTube女YouTuber和她男友從監獄逃脫。在這個雙人冒險遊戲中，他們必須收集所有的YouTube獎牌，不至於分得太開，獲得金鑰和金色獎牌，並到達櫃子。打開櫃子，然後跑到門口。你必須非常快，你必須逃出監獄！",
      "instructions": "*使用\"WASD\"和\"箭頭鍵\"來移動。\n*可進行雙重跳躍。\n*收集所有YouTube獎牌並找到鑰匙。\n*找到鑰匙後，到達箱子。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2D",
        "雙人遊戲",
        "Minecraft",
        "平台遊戲",
        "經營遊戲"
      ]
    },
    "zh-HK": {
      "title": "油管主Mcraft 2Player",
      "description": "你需要幫助那位YouTube女YouTuber和她男友從監獄逃脫。在這個雙人冒險遊戲中，他們必須收集所有YouTube獎牌，同時不能走得太遠，取得鑰匙和金屬獎牌，並達到櫃子前。打開櫃子，然後跑到門口。你必須非常快，你必須逃出監獄！",
      "instructions": "*使用「WASD」及「方向鍵」移動。\n*可進行雙重跳躍。\n*收集所有YouTube獎牌並尋找金鑰。\n*找到金鑰後，走到櫃子處。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2D",
        "2人玩",
        "Minecraft",
        "平台遊戲",
        "經營遊戲"
      ]
    },
    "ja": {
      "title": "YouTubeユーチューバーMcraff 2Player",
      "description": "YouTuberの女の子と彼の彼氏を刑務所から逃がす必要があります。この二人用のアドベンチャーゲームでは、YouTubeのメダルをすべて集め、離れすぎないようにし、鍵と金のメダルを手に入れ、宝箱にたどり着きます。宝箱を開け、ドアに駆け寄ります。とても速く動かなければならないので、刑務所から逃げ出すことになります！",
      "instructions": "*“WASD”および“矢印キー”を使って移動。\n*ダブルジャンプ可能。\n*すべてのYouTubeのメダルを集め、鍵を見つけ。\n*鍵を見つけたら、宝箱にたどり着く。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "2D",
        "2人用",
        "マインクラフト",
        "プラットフォーム",
        "タイトン"
      ]
    },
    "ko": {
      "title": "유튜버 Mcraft 2플레이어",
      "description": "유튜버 여자와 그녀의 남친을 감옥에서 탈출시켜야 합니다. 이 두인용 어드벤처에서는 유튜브 메달을 모두 수집하면서 서로 멀리 떨어지지 않도록 해야 하며, 열쇠와 금메달을 얻고 가슴을 찾아야 합니다. 가슴을 열고 문으로 달려가야 합니다. 매우 빠르게 해야 하며, 감옥에서 탈출해야 합니다!",
      "instructions": "* \"WASD\"와 \"矢印 키\"를 사용하여 이동하세요.\n* 더블 점프 가능.\n* 모든 YouTube 표를 수집하고 열쇠를 찾으세요.\n* 열쇠를 찾은 후 가슴을 찾으세요.",
      "genres": [
        "모험"
      ],
      "tags": [
        "2D",
        "2인",
        "마인크래프트",
        "플랫폼게임",
        "테이크오버"
      ]
    },
    "fr": {
      "title": "Youtuber Mcraft 2Player",
      "description": "Vous devez aider la fille YouTuber et son petit ami à s'échapper de prison. Dans cette aventure à deux joueurs, ils doivent ramasser toutes les plaques YouTube sans s'éloigner trop, obtenir la clé et la plaque d'or, et atteindre le coffre. Ouvrez le coffre et courez vers la porte. Vous devez être très rapide, vous devez vous échapper de prison !",
      "instructions": "*Utilisez les touches \"WASD\" et les flèches directionnelles pour vous déplacer.\n*Double saut disponible.\n*Récupérez toutes les plaques YouTube et trouvez la clé.\n*Après avoir trouvé la clé, atteignez le coffre.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "2D",
        "2 joueurs",
        "Minecraft",
        "plate-forme",
        "tycoon"
      ]
    }
  }
};
